import { render } from "./CustomerAddressFields.vue?vue&type=template&id=4289c07d"
import script from "./CustomerAddressFields.vue?vue&type=script&lang=js"
export * from "./CustomerAddressFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__